import React from 'react';
import SpotIMContainer from '../common/spot_im_container';
import { getArticleTag } from '../../vendor/beacons/spot_im';
import PropTypes from 'prop-types';

export const Comments = ({ comments_id, url_full, darkTheme, primary_category, spotID }) => (
  <SpotIMContainer spotID={spotID}
    renderID={comments_id}
    className="spot-im-comments-container"
    scriptURL={`https://launcher.spot.im/spot/${spotID}`}
    scriptOptions={{
      async: true,
      attrs: {
        'data-spotim-module': 'spotim-launcher',
        'data-post-url': url_full,
        'data-post-id': comments_id,
        'data-article-tags': getArticleTag(primary_category),
        'data-messages-count': 3,
        'data-sort-by': 'best',
        'data-conversation-skin': darkTheme ? 'dark' : 'light'
      }
    }}
  />
);

Comments.propTypes = {
  comments_id: PropTypes.string.isRequired,
  url_full: PropTypes.string.isRequired,
  primary_category: PropTypes.object, // No longer required to allow Preview of articles without error
  spotID: PropTypes.string.isRequired,
  darkTheme: PropTypes.bool
};

export default Comments;
